import { IconButton, TextField } from '@mui/material'
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import { useNavigate } from 'react-router-dom';
import './SearchBar.scss'
import {useTheme} from '@mui/material/styles'

export default function SearchBar(props) {
  const theme = useTheme()
  const navigate = useNavigate()

  const handleSearch = (event) => {
    event.preventDefault()
    navigate('/search/' + event.target[0].value)
  }

  return (
    <div>
      <div className="row searchBar" style={{maxWidth: '100%', marginTop:'25px', marginBottom: '25px'}}>
        <div className="col-9">
          <form onSubmit={handleSearch} >
            <div className='searchBar searcher'>
              <div className="row">
                <TextField label="cerca" variant="standard" className="col-10"/>
                <IconButton type='submit' className='col-2'>
                  <SearchRoundedIcon />
                </IconButton>
              </div>
            </div>
          </form>
        </div>
        <div className="col-3">
          <p className='searchBar string' style={{color:theme.palette.secondary.main}}>My meteo</p>
        </div>
      </div>
    </div>
  )
}